export const Data = [

    {
      title: "<b>Software Developer</b> @ <a href='https://servoitsolutions.ph/' style=' text-decoration: none;color: gold;'>Servo IT Solutions</a>",
      tenure: "May 2017 - Present",
      details: "<ul><li>Co-developed and designed major features of an Accounting System.</li><li>Developed a Timekeeping System with integration to the payroll system and face recognition hardwares.</li><li>Developed a web employee portal page integrated to the Timekeeping and Payroll System. </li></ul>",
      others: ""
    }
];
  
  
  